module.exports = __webpack_public_path__ + "img/在线教育6.683cb873.png";